import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { apiClient } from "@/api/client"
import { ConsumptionType, ProductCreateDto } from "@/api/api-client"

export interface ProductFilters {
  searchTerm?: string
  categoryId?: number
  providerIds?: number[]
  minPrice?: number
  maxPrice?: number
  minWeight?: number
  maxWeight?: number
  sortBy?: string
  page?: number
  pageSize?: number
  consumptionType?: ConsumptionType
}

export const useProducts = (filters: ProductFilters = {}) => {
  return useQuery({
    queryKey: ["products", filters],
    queryFn: () =>
      apiClient.getAllProducts(
        filters.searchTerm,
        filters.categoryId,
        filters.providerIds,
        filters.minPrice,
        filters.maxPrice,
        filters.minWeight,
        filters.maxWeight,
        filters.sortBy,
        filters.page,
        filters.pageSize,
        filters.consumptionType
      ),
  })
}

export const useProduct = (id: number | undefined) => {
  return useQuery({
    queryKey: ["product", id],
    queryFn: () => apiClient.getProductById(id!),
    enabled: !!id,
  })
}

export const useVendorProducts = () => {
  return useQuery({
    queryKey: ["vendor-products"],
    queryFn: () => apiClient.getVendorProducts(),
  })
}

export const useCreateProduct = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (newProduct: ProductCreateDto) => apiClient.createProduct(newProduct),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] })
    },
  })
}

